import { api } from "../api/requests";

// Check loan status
export function verifyLoanAndReconcileLoanStatus(applicationNumber: string) {
  return new Promise<any>((resolve, reject) => {
    api
      .get(`/admin/loans/${applicationNumber}/reconcile-payment-status`)
      .then((response: any) => {
        resolve(response?.data?.data);
      })
      .catch((error: Error) => {
        reject(error);
      });
  });
}
